import { readPageProject } from '@/schema/page-project'
import { builtinResourceUrl } from './builtin-resource-url'

const fileId = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(value) ? value : ''
export function projectCoverFileId (record) {
  if (fileId(record.coverFileId)) return record.coverFileId
  let metadata = record.metadata
  try { if (typeof metadata === 'string') metadata = JSON.parse(metadata) } catch (_) { return '' }
  const url = metadata && metadata.visual && metadata.visual.backgroundUrl
  if (typeof url !== 'string') return ''
  // 兼容旧平台文件地址；外部图片或带访问参数的地址不推断为可复用文件。
  const match = url.match(/^(?:https?:[/][/][^/?#]+)?[/](?:jetlinks[/]|api[/])?file[/]([A-Za-z0-9_-]{1,64})(?:[.]png)?$/)
  return match ? match[1] : ''
}
export const projectCoverUrl = record => fileId(record.coverFileId) ? builtinResourceUrl(record.coverFileId) || '/jetlinks/file/' + record.coverFileId + '.png' : ''
// 使用正式项目首页，保留所有平台组件；不受模板组件白名单和500 KB限制。
export function projectCoverSnapshot (record) {
  const model = readPageProject(record)
  return { kind: 'page', width: model.config.width, height: model.config.height, config: model.config, nodes: model.nodes }
}
